import {Component, Module} from 'app/decorators';
import _ from 'lodash';

import BasePicker from 'app/directives/base.picker';
import EmailToStore from 'app/stores/emailto.js'

import tpl from './emailto.component.html';


@Module({
    name: "app.admin.components.emailto",
    modules: [
        EmailToStore,
    ],
})
@Component({
    selector: 'blnd-email-to',
    bindings: {
        ngModel: '=',
        mode: '@',
    },
    template: tpl,
})
export default class C extends BasePicker {
    constructor(EmailToStore) {
        "ngInject";
        super();
        this.mode = this.mode || 'view';
        this.store = EmailToStore;
        this.store.init();
        this.items = [];
    }

    tagTransform (newTag) {
        return {
            email:  newTag,
        };
    }

    refresh (search) {
        let self = this;

        if (!this.enabled) { return; }
        this.store.params.search = search;
        this.store.refresh().then(function (obj) {
            self.items = _.map(obj.list, (o) => {
                return {
                    email: o.email,
                };
            });
         });
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/components/emailto.component.js